import React, { ReactNode } from 'react';

interface ConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: ReactNode) => JSX.Element;
  elseWrapper?: (children: ReactNode) => JSX.Element;
  children: ReactNode;
}

const ConditionalWrapper = ({
  condition,
  wrapper,
  elseWrapper = (children) => <>{children}</>,
  children,
}: ConditionalWrapperProps): JSX.Element =>
  condition ? wrapper(children) : elseWrapper(children);

export default ConditionalWrapper;
